'use strict';


module.exports = {
  NAV_BAR: 'NavBar',
  INFO_PANEL: 'InfoPanel',
  LIGHTBOX: 'Lightbox',
  STAMP_PAGE_CONTROLS: 'StampPageControls',
  ZINE_PAGE_CONTROLS: 'ZinePageControls',
  USER_PAGE_CONTROLS: 'UserPageControls',
  IMAGE_CONTROLS: 'ImageControls',
  ALERT: 'Alert',
  NOTIFICATION: 'Notification',
  PINTEREST_PICKER: 'PinterestPicker',
  ABOUT_FORM: 'AboutForm',
  ABOUT_PAGE_WELCOME: 'AboutPage.welcome',
  ABOUT_PAGE_SIGNUP: 'AboutPage.signUp',
  CALL_TO_JOIN: 'CallToJoin',
  SHOW_SIDEBAR: 'showSidebar',
  LIKE_STAMP: 'likeStamp',
  FOLLOW_ZINE: 'followZine',
  FOLLOW_USER: 'followUser',
  BEST_OF_2014_SPECIAL: 'bestOf2014Special'
};



/** WEBPACK FOOTER **
 ** ./constants/AnalyticsSources.js
 **/